// material-ui

// project import
//import getColors from 'utils/getColors';
// import getShadow from 'utils/getShadow';

// ==============================|| CARD HEADER - COLORS ||============================== //

function getCardHeaderStyle({ color, theme }) {
  //const colors = getColors(theme, color);
  //const { lighter, main, dark, contrastText } = colors;

  // const shadow = getShadow(theme, `${color}CardHeader`);

  return {
    //backgroundColor: theme.palette.mode === 'dark' ? dark : main,
    // backgroundColor: theme.palette.mode === 'dark' ? dark : '#ddd',
    // color: theme.palette.mode === 'dark' ? contrastText : dark,
    // boxShadow: theme.palette.mode === 'dark' ? shadow : 'none',
  };
}

// ==============================|| OVERRIDES - CARD HEADER ||============================== //

export default function CardHeader(theme) {
  const primaryCardHeader = getCardHeaderStyle({ color: 'primary', theme });

  return {
    MuiCardHeader: {
      styleOverrides: {
        root: {
          ...primaryCardHeader,
          '& .MuiCardHeader-content': {
            color: primaryCardHeader.color,
          },
        },
      },
    },
  };
}
